import { PasswordResetLinkCreatorComponent } from 'components';
import { APP_ROUTES } from 'constants/AppRoutes';

const PasswordResetUser = () => (
	<PasswordResetLinkCreatorComponent signInLink={APP_ROUTES.SIGN_IN_USER} />
);

export default PasswordResetUser;
